var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.debugInterval)?_c('pre',{staticClass:"participant-debug-info",on:{"click":function($event){$event.stopPropagation();return _vm.toggleParticipantDebugInfo.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.debugInfo))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }